// extracted by mini-css-extract-plugin
export default {"mainTags":"Main_mainTags__hjBfG","mainContaier":"Main_mainContaier__8Qi+-","buttonTag":"Main_buttonTag__t8HXu"};